import { buildNotificationBlockValue } from './buildNotificationBlockValue';
import { CHANNELS, NOTIFICATION_BLOCK, TARGETS } from 'constants/MeshbotConstant';

export const buildForwardNotificationsFields = (config, currentNotificationBlockFields) => {
    const { channels } = config || {};

    return (
        currentNotificationBlockFields?.map((field) => {
            if (field.name === TARGETS && channels) {
                return {
                    ...field,
                    value: field.value.map((item) => {
                        if (item.hasOwnProperty(CHANNELS)) {
                            return {
                                ...item,
                                channels,
                            };
                        }

                        return item;
                    }),
                };
            }

            if (field.name === NOTIFICATION_BLOCK) {
                return {
                    ...field,
                    value: buildNotificationBlockValue(currentNotificationBlockFields, config),
                };
            }

            return field;
        }) || []
    );
};
